import type { ExtensionParams, Parameters } from '@atlaskit/editor-common/extensions';

export type ExtensionParameters<T extends Parameters> = {
	extensionNode?: ExtensionParams<T>;
	contentId: string;
};

export enum CommonLayout {
	FRAME_ABOVE_IMAGE = 'frame-above-image',
	SPLIT_IMAGE_RIGHT = 'split-image-right',
	SPLIT_IMAGE_LEFT = 'split-image-left',
	FULL_IMAGE_BACKGROUND = 'full-image-background',
	NO_IMAGE_BACKGROUND = 'no-image-background',
}
